import { copy } from './copy';
import { useAlert } from '@/composables';
import { SHARE_MESSAGE, SHARE_TYPE, ShareType } from '@/constants';

/** share Props interface */
interface ShareProps {
  type: ShareType;
  seq: number;
  itemSeq?: number;
}

const shareBaseUrl = `${process.env.VUE_APP_API_BASE_URL}/share`;

/** 복사 완료 안내 메세지. */
const messageMap: Record<ShareType, string> = {
  [SHARE_TYPE.BOOK]: SHARE_MESSAGE.BOOK,
  [SHARE_TYPE.KIDS_BOOK]: SHARE_MESSAGE.BOOK,
  [SHARE_TYPE.SERIAL]: SHARE_MESSAGE.SERIAL,
  [SHARE_TYPE.SERIAL_ITEM]: SHARE_MESSAGE.SERIAL,
  [SHARE_TYPE.WEBTOON]: SHARE_MESSAGE.WEBTOON,
  [SHARE_TYPE.NOVEL]: SHARE_MESSAGE.NOVEL,
  [SHARE_TYPE.CONTEST_INFO]: SHARE_MESSAGE.CONTEST_INFO,
  [SHARE_TYPE.CONTEST_WINNER]: SHARE_MESSAGE.CONTEST_WINNER,
};

/** 도서, 키즈, 연재, 연재 상세 url 반환 */
const getUrl = ({ type, seq, itemSeq }: ShareProps) => {
  switch (type) {
    case SHARE_TYPE.BOOK:
      return `${shareBaseUrl}/book/${seq}`;
    case SHARE_TYPE.KIDS_BOOK:
      return `${shareBaseUrl}/kids-book/${seq}`;
    case SHARE_TYPE.SERIAL:
      return `${shareBaseUrl}/serial/${seq}`;
    case SHARE_TYPE.SERIAL_ITEM:
      return `${shareBaseUrl}/serial/${seq}/items/${itemSeq}`;
    case SHARE_TYPE.WEBTOON:
      return `${shareBaseUrl}/webtoon/${seq}`;
    case SHARE_TYPE.NOVEL:
      return `${shareBaseUrl}/novel/${seq}`;
    case SHARE_TYPE.CONTEST_INFO:
      return `${shareBaseUrl}/contest/${seq}`;
    case SHARE_TYPE.CONTEST_WINNER:
      return `${shareBaseUrl}/contest/winner/${seq}`;
  }
};

/** 도서, 키즈, 연재, 연재 상세 공유 url 을 클립보드에 복사하는 함수. */
export const share = ({ type, seq, itemSeq }: ShareProps) => {
  const alertModal = useAlert();
  const url = getUrl({ type, seq, itemSeq });

  // 클립보드에 url 복사.
  copy(url).then(() => {
    // 복사 이후 유형에 맞는 안내 메세지 alert 처리.
    alertModal.show({
      message: messageMap[type],
    });
  });
};
